import PackagingService from '@/api/packaging/packagingService';
/* eslint-disable */

export const packaging = {
  namespaced: true,
  state: () => ({
    packagingList: []
  }),

  getters: {
    getPackagingList(state) {
      return state.packagingList;
    },
    
  },

  mutations: {
    SET_PACKAGING_LIST(state, payload) {
      state.packagingList = payload;
    },
  },

  actions: {

    async fetchPackagingList({ commit, state }, list) {
      try {
        const res = await PackagingService.getPackaging();
        commit('SET_PACKAGING_LIST', [...res.data.data]);
      } catch (error) {
        console.log('GET SET_PACKAGING_LIST', error);
      } finally {
        state.loading = false;
      }
    },
  }
};
